import React from 'react';
import { IconRotateM } from '../../icons';
import { somePeriodAgo } from '../../util/dates';
import config from '../../config';
import css from './IdentitySection.css';
import { RIDER_AVAILABILITY_NOT_AVAILABLE } from '../../marketplace-custom-config';

const { newListingNumberOfDays, listingTypeHorse } = config;

const BadgeReactivatedListing = ({ currentListing }) => {
    const past = somePeriodAgo(newListingNumberOfDays, 'day');
    const {
        type,
        /** rider */
        userRepresentationId,
        availabilityUpdatedAtLong,
        user_availabilityStatusPrevious,
        /** horse */
        lifetimeUpdatedAt,
        listingStatePrevious,
    } = currentListing.attributes.publicData;

    const isUserListing = !!userRepresentationId;
    const wasNotAvailable = user_availabilityStatusPrevious === RIDER_AVAILABILITY_NOT_AVAILABLE;
    const isReactivatedRider =
        isUserListing && wasNotAvailable && past < new Date(availabilityUpdatedAtLong);

    const isHorseListing = !userRepresentationId && type === listingTypeHorse;
    const wasClosed = listingStatePrevious === 'closed';
    const isReactivatedHorse = isHorseListing && wasClosed && past < new Date(lifetimeUpdatedAt);

    const showBadge = isReactivatedRider || isReactivatedHorse;

    return showBadge ? (
        <div className={css.listingCardBadge}>
            <IconRotateM />
            <span>Frisch zurück</span>
        </div>
    ) : null;
};

export default BadgeReactivatedListing;
